import {
  Badge,
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  Flex,
  HStack,
  Heading,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PinInput,
  PinInputField,
  Stack,
  StackDivider,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
  FormControl,
  FormLabel,
  Select, // Import Select component for dropdown
} from "@chakra-ui/react";
import {
  CloseIcon,
  EditIcon,
  EmailIcon,
  PhoneIcon
} from "@chakra-ui/icons";
import {
  MDBInput
} from "mdb-react-ui-kit";
import React, {
  useEffect,
  useState
} from "react";
import {
  Link
} from "react-router-dom";
import CatNavbar from "./CatNavbar";
import axios from "axios";
import {
  Spinner
} from "react-bootstrap";
import { API_BASE_URL } from "./config/api_keys";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import GppBadIcon from "@mui/icons-material/GppBad";
import logo from "./resources/logo.jpeg";
import StartIcon from "@mui/icons-material/Start";
import { GpsFixed } from "@mui/icons-material"; // Import a location icon
import { businessCategories } from "./resources/Catagories"; // Import business categories

export default function UserProfileEdit() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setSending] = useState(false);
  const [verifyscr, Setverifyscr] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [pin, setPin] = useState("");
  const toast = useToast();
  const picture = localStorage.getItem("authpicture");
  const [imageUrl, setImageUrl] = useState(picture);

  // States for Businessman Feature
  const [isUserBusinessman, setIsUserBusinessman] = useState(false);
  const [bizState, setBizState] = useState('');
  const [bizCity, setBizCity] = useState('');
  const [bizArea, setBizArea] = useState('');
  const [bizCategory, setBizCategory] = useState(''); // New state for business category
  const [isLocating, setIsLocating] = useState(false);
  const [coordinates, setCoordinates] = useState(null); // State to hold coordinates
  const {
    isOpen: isBizModalOpen,
    onOpen: onBizModalOpen,
    onClose: onBizModalClose
  } = useDisclosure();


  const OverlayOne = () => ( <
    ModalOverlay bg = "blackAlpha.100"
    backdropFilter = "blur(6px)" / >
  );
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const [overlay, setOverlay] = React.useState( < OverlayOne / > );
  const authemail = localStorage.getItem("authemail");
  const authphone = localStorage.getItem("authphone");

  // Fetch full user details on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(`${API_BASE_URL}/verification-status?email=${authemail}`);
        const data = await response.json();
        setIsVerified(data.isVerified);
        const bizStatus = localStorage.getItem("isBusinessman");
        if (bizStatus === 'true') {
          setIsUserBusinessman(true);
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    if (authemail) {
      fetchUserData();
    }
  }, [authemail]);

  useEffect(() => {
    const authname = localStorage.getItem("authname");
    if (authname) {
      setName(authname);
    }
    if (authemail) {
      setEmail(authemail);
    }
    if (authphone) {
      setPhoneNumber(authphone);
    }
  }, []);


  function handleNameChange(event) {
    setName(event.target.value);
  }

  function handlePhoneChange(event) {
    setPhoneNumber(event.target.value);
  }

  function handleEmailChange(event) {
    setEmail(event.target.value);
  }

  const handleSendOtp = async (event) => {
    setSending(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/send-verification-email`, {
        email
      });
      console.log(response);
      Setverifyscr(true);
      toast({
        title: "Verification Email Sent",
        description: "Enter 4-digit OTP.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
      toast({
        title: "Error",
        description: "An error occurred while sending the verification email.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setSending(false);
    }
  };

  const handlePinSubmit = async (value) => {
    setPin(value);
    setSending(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.post(
        `${API_BASE_URL}/verify-email`, {
          pin: value,
          email: email
        }, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      localStorage.setItem("authemail", response.data.email);
      localStorage.setItem("authname", response.data.name);
      localStorage.setItem("authToken", response.data.token);
      onClose();
      Setverifyscr(false);
      setIsVerified(true); // Update state on success
      console.log("Email verification response:", response.data);
      toast({
        title: "Success",
        description: "Email verified successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error verifying email:", error);
      toast({
        title: "Error",
        description: "Email verification failed.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSending(false);
    }
  };


  const handleImageChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setImageUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    if (phoneNumber.length !== 10) {
      toast({
        title: 'Error',
        description: 'Phone number should be 10 digits.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    setIsLoading(true);
    try {
      const authToken = localStorage.getItem('authToken');
      let imageUrlToSend = imageUrl;
      
      if (imageUrl && imageUrl.startsWith('data:image')) {
        // Convert data URL to file and upload to server
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const file = new File([blob], 'profile.jpg', { type: 'image/jpeg' });
        
        const formData = new FormData();
        formData.append('image', file);
        
        // Show uploading state
        setIsLoading(true);
        
        // Add upload progress tracking
        const uploadResponse = await axios.post(
          `${API_BASE_URL}/upload-profile-image`,
          formData,
          {
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'multipart/form-data',
            },
            // Add timeout for large files
            timeout: 10 * 60 * 1000, // 10 minutes
          }
        );
        imageUrlToSend = uploadResponse.data.imageUrl;
      }
      
      const response = await axios.post(
        `${API_BASE_URL}/profile_edit`, {
          name,
          imageUrl: imageUrlToSend,
          phoneNumber
        }, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      localStorage.setItem('authname', response.data.name);
      localStorage.setItem('authphone', response.data.phone);
      localStorage.setItem('authpicture', response.data.picture);
      toast({
        title: 'Success',
        description: 'Profile updated successfully.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error during profile update:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      
      let errorMessage = 'An error occurred while updating the profile.';
      
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      toast({
        title: 'Error',
        description: errorMessage,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // --- Businessman Feature Functions ---
  const handleOpenBizModal = () => {
    if (!phoneNumber || phoneNumber.length !== 10) {
      toast({
        title: "Phone Number Required",
        description: "Please add and save a valid 10-digit phone number before joining as a businessman.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    onBizModalOpen();
  };

  // MODIFIED function to get location AND autofill address
  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      return toast({
        title: "Geolocation not supported",
        description: "Your browser does not support this feature.",
        status: "error",
        isClosable: true,
      });
    }

    setIsLocating(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setCoordinates({ latitude, longitude });

        try {
          // NEW: Call the reverse-geocode endpoint
          const { data } = await axios.post(`${API_BASE_URL}/reverse-geocode`, {
            latitude,
            longitude
          });

          // Autofill the form fields
          setBizState(data.state || '');
          setBizCity(data.city || '');
          setBizArea(data.area || '');
          
          toast({
            title: "Location Found!",
            description: "Your address has been filled automatically. Please review it.",
            status: "success",
            isClosable: true,
          });

        } catch (error) {
          toast({
            title: "Could not fetch address",
            description: "Location was found, but the address could not be determined. Please fill it manually.",
            status: "warning",
            isClosable: true,
          });
        } finally {
          setIsLocating(false);
        }
      },
      () => {
        setIsLocating(false);
        toast({
          title: "Unable to retrieve location",
          description: "Please enable location permissions for this site.",
          status: "error",
          isClosable: true,
        });
      }
    );
  };

  const handleJoinBusinessman = async () => {
    if (!bizState || !bizCity || !bizArea || !bizCategory) {
      return toast({
        title: "Required Fields Missing",
        description: "Please fill in all required fields: State, City, Area, and Business Category.",
        status: "warning",
        isClosable: true,
      });
    }

    setIsLoading(true);
    try {
      const authToken = localStorage.getItem('authToken');
      const payload = {
        state: bizState,
        city: bizCity,
        area: bizArea,
        businessCategory: bizCategory, // Include business category
      };

      if (coordinates) {
        payload.latitude = coordinates.latitude;
        payload.longitude = coordinates.longitude;
      }

      const response = await axios.post(
        `${API_BASE_URL}/join-businessman`,
        payload, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setIsUserBusinessman(true);
      localStorage.setItem('isBusinessman', 'true');

      toast({
        title: "Success!",
        description: response.data.message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      onBizModalClose();

    } catch (error) {
      toast({
        title: "Error",
        description: error.response?.data?.message || "An error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };


  return ( 
    <div>
        <div className = "container" >
            <Card className = "mt-4 mb-4" >
                <form onSubmit = {handleFormSubmit} >
                    <CardHeader >
                        <div style = {{ display: "flex", justifyContent: "space-between"}} >
                            <Heading size = "md" className = "mt-3" >
                                Edit Profile 
                            </Heading> 
                            <Link to = "/profile" >
                                <Button className = "mt-2" > View Profile </Button> 
                            </Link> 
                        </div> 
                    </CardHeader> 
                    <Divider />
                    <CardBody >
                        <Stack divider = {<StackDivider/>} spacing = {4} >
                            <Box >
                                <Heading size = "xs" textTransform = "uppercase" mr = {2} textAlign = "left" >
                                    Basic information 
                                </Heading> 
                                <div className = "custom-file-input mt-4" >
                                    <MDBInput label = "Name" id = "name" value = {name} onChange = {handleNameChange} required />
                                </div> 
                            </Box> 
                            <Box >
                                <Heading size = "xs" textTransform = "uppercase" mr = {2} textAlign = "left" >
                                    Contact information 
                                </Heading> 
                                <div className = "custom-file-input mt-4" >
                                    <InputGroup >
                                        <InputLeftElement pointerEvents = "none" >
                                            <EmailIcon color = "green.300" />
                                        </InputLeftElement> 
                                        <Input type = "email" placeholder = "Email" value = {authemail || ''} onClick = {() => {setOverlay( < OverlayOne / > ); onOpen();}} readOnly required/> 
                                        {isVerified ? ( 
                                            <Badge className = "mx-2 my-auto" variant = "solid" colorScheme = "green" >
                                                <VerifiedUserIcon fontSize="small" /> Verified 
                                            </Badge>
                                        ) : ( 
                                            <Badge className = "mx-2 my-auto" variant = "solid" colorScheme = "red" >
                                                <GppBadIcon fontSize="small" /> Not Verified 
                                            </Badge>
                                        )} 
                                    </InputGroup> 
                                    <InputGroup className = "mt-3" >
                                        <InputLeftElement pointerEvents = "none" children = {<PhoneIcon color = "green.300" />} />
                                        <Input type = "tel" placeholder = "Phone Number" required value = {phoneNumber} onChange = {handlePhoneChange}/> 
                                    </InputGroup> 
                                </div> 
                            </Box>
                            {/* --- START: Businessman Section --- */} 
                            <Box >
                                <Heading size = "xs" textTransform = "uppercase" mr = {2} textAlign = "left" >
                                    Trader Profile 
                                </Heading> 
                                <Box mt = {4} > 
                                {isUserBusinessman ? ( 
                                    <Badge colorScheme = "green" p = {2} borderRadius = "md" >
                                        You are registered as a Trader. 
                                    </Badge>
                                ) : ( 
                                    <Button colorScheme = "teal" onClick = {handleOpenBizModal} >
                                        Join as a Trader 
                                    </Button>
                                )} 
                                </Box> 
                            </Box> 
                            {/* --- END: Businessman Section --- */}
                            <Box >
                                <Heading size = "xs" textTransform = "uppercase" mr = {2} textAlign = "left" >
                                    Edit Picture 
                                </Heading> 
                                <div className = "mt-4 mx-4" >
                                    <Box position = "relative" style = {{display: "flex", alignItems: "center"}} > 
                                    {imageUrl && ( 
                                        <Tooltip label = "Clear Image" placement = "top" >
                                            <IconButton icon = {<CloseIcon />} size = "sm" borderRadius = "full" colorScheme = "red" position = "absolute" top = "-8px" left = "-8px" zIndex = "1"
                                                onClick = {() => setImageUrl("https://cdn-icons-png.flaticon.com/512/3135/3135715.png")}
                                                _hover = {{color: "purple.600"}}
                                            /> 
                                        </Tooltip>
                                    )} 
                                    <Image borderRadius = "full" boxSize = "100px" src = {imageUrl} alt = "Profile Picture" />
                                    <div className = "custom-file-input" >
                                        <Input className = "mt-3" type = "file" border = "none" onChange = {handleImageChange} accept="image/*" />
                                    </div> 
                                    </Box> 
                                </div> 
                            </Box> 
                        </Stack> 
                    </CardBody> 
                    <Divider />
                    <CardFooter style = {{display: "flex", justifyContent: "space-between"}} >
                        <Link to = "/profile" >
                            <Button variant = "ghost" colorScheme = "blue" >
                                Discard 
                            </Button> 
                        </Link> 
                        <Button type = "submit" variant = "solid" colorScheme = "blue" isLoading = {isLoading} loadingText = "Saving..." >
                            Save Changes 
                        </Button> 
                    </CardFooter> 
                </form> 
            </Card> 
        </div>

        {/* Verify Email Modal Here */} 
        <Modal isCentered closeOnOverlayClick = {false} isOpen = {isOpen} onClose = {onClose} size = "md" > 
            {overlay} 
            {verifyscr === false && ( 
                <ModalContent >
                    <Flex alignItems = "center" justifyContent = "center" className = "mt-4 mb-4" >
                        <Image borderRadius = "full" boxSize = "70px" src = {logo} alt = "Logo" />
                        <Box mx = "8" color = "blue.500" >
                            <StartIcon boxSize = {10} />
                        </Box> 
                        <Image borderRadius = "full" boxSize = "100px" src = {picture} alt = "Account Picture" />
                    </Flex> 
                    <ModalHeader className = "text-center" >
                        <Heading >
                            <h5> Enter your email to verify your account </h5> 
                        </Heading> 
                    </ModalHeader> 
                    <ModalCloseButton />
                    <ModalBody className = "mb-4 text-center" >
                        <Text color = "rebeccapurple" >
                            We will send a confirmation code to your email 
                        </Text> 
                        <InputGroup className = "mb-4 mt-2" >
                            <InputLeftElement pointerEvents = "none" children = {<EmailIcon color = "gray.300" />} />
                            <Input type = "email" placeholder = "Email" value = {email} onChange = {handleEmailChange} />
                        </InputGroup> 
                        <small style = {{color: "gray"}} >
                            The email you provide here is only used to verify your account. It will not be made public. 
                        </small> 
                    </ModalBody> 
                    <ModalFooter className = "mt-4" >
                        <Flex justify = "flex-end" align = "center" w = "100%" >
                            <Button variant = "solid" borderRadius = "10" size = "lg" boxShadow = "md" borderWidth = "1px" borderColor = "gray.300" flex = "1" marginLeft = "auto" marginRight = "auto" onClick = {handleSendOtp} isLoading = {isSending} loadingText = "Sending OTP..." >
                                Next 
                            </Button> 
                        </Flex> 
                    </ModalFooter> 
                </ModalContent>
            )} 
            {verifyscr === true && ( 
                <ModalContent >
                    <Flex alignItems = "center" justifyContent = "center" className = "mt-4 mb-4" >
                        <Image borderRadius = "full" boxSize = "70px" src = {logo} alt = "Logo" />
                        <Box mx = "8" color = "blue.500" >
                            <StartIcon boxSize = {10} />
                        </Box> 
                        <Image borderRadius = "full" boxSize = "100px" src = {picture} alt = "Account Picture" />
                    </Flex> 
                    <ModalHeader className = "text-center" >
                        <Heading >
                            <h5> Enter verification code </h5> 
                        </Heading> 
                    </ModalHeader> 
                    <ModalCloseButton />
                    <ModalBody className = "mb-4 text-center" >
                        <Flex align = "center" justify="center">
                            <Text color = "rebeccapurple" >
                                We sent a 4 - digit code to < b > {email} < /b> 
                            </Text> 
                            <Tooltip label = "Edit email" placement = "top" >
                                <IconButton variant="ghost" icon = {<EditIcon color = "blue" />} onClick = {() => Setverifyscr(false)} _hover = {{color: "green.500"}}/> 
                            </Tooltip> 
                        </Flex>
                        <InputGroup className = "mb-4 mt-4" justifyContent = "center" alignItems = "center" display = "flex" flexDir = "column" >
                            <HStack className = "mt-4 mb-4" spacing = {4} >
                                <PinInput size = "lg" otp onComplete = {handlePinSubmit} >
                                    <PinInputField _focus = {{borderColor: "primary.500"}} />
                                    <PinInputField _focus = {{borderColor: "primary.500"}} />
                                    <PinInputField _focus = {{borderColor: "primary.500"}} />
                                    <PinInputField _focus = {{borderColor: "primary.500"}} />
                                </PinInput> 
                            </HStack> 
                        </InputGroup> 
                        {isSending && ( 
                            <div className = "container" >
                                <Spinner thickness = "4px" speed = "0.65s" emptyColor = "black.200" color = "red.500" size = "xl" />
                            </div>
                        )} 
                        <Button variant="link" size="sm" onClick = {handleSendOtp} >
                            Request a new code 
                        </Button> 
                    </ModalBody> 
                </ModalContent>
            )} 
        </Modal>

        {/* --- MODIFIED: Join as Businessman Modal --- */} 
        <Modal isOpen = {isBizModalOpen} onClose = {onBizModalClose} isCentered >
            <ModalOverlay />
            <ModalContent >
                <ModalHeader > Become a Trader </ModalHeader> 
                <ModalCloseButton />
                <ModalBody pb = {6} >
                    <Stack spacing={4}>
                        <Text color="gray.600">
                            For the best accuracy, use your device's location. Otherwise, enter your address manually.
                        </Text>
                        
                        <Button
                            colorScheme="teal"
                            leftIcon={<GpsFixed />}
                            onClick={handleGetLocation}
                            isLoading={isLocating}
                            loadingText="Finding Location..."
                        >
                            Use My Current Location
                        </Button>

                        {coordinates && (
                            <Badge colorScheme="green" p={2} textAlign="center" borderRadius="md">
                                ✓ Precise location captured! Please review the auto-filled address.
                            </Badge>
                        )}
                        
                        <Divider />
                        
                        <FormControl isRequired >
                            <FormLabel > State </FormLabel> 
                            <Input placeholder = 'e.g., Maharashtra' value = {bizState} onChange = {(e) => setBizState(e.target.value)} />
                        </FormControl> 
                        
                        <FormControl isRequired >
                            <FormLabel > City </FormLabel> 
                            <Input placeholder = 'e.g., Mumbai' value = {bizCity} onChange = {(e) => setBizCity(e.target.value)} />
                        </FormControl> 
                        
                        <FormControl isRequired >
                            <FormLabel > Area / Locality </FormLabel> 
                            <Input placeholder = 'e.g., Andheri West' value = {bizArea} onChange = {(e) => setBizArea(e.target.value)} />
                        </FormControl> 
                        
                        <FormControl isRequired >
                            <FormLabel > Trader Category </FormLabel> 
                            <Select placeholder = 'Select your business category' value = {bizCategory} onChange = {(e) => setBizCategory(e.target.value)} >
                                {businessCategories.map((category, index) => (
                                    <option key={index} value={category}>{category}</option>
                                ))}
                            </Select>
                        </FormControl> 
                    </Stack>
                </ModalBody> 
                <ModalFooter >
                    <Button colorScheme = 'blue' mr = {3} onClick = {handleJoinBusinessman} isLoading = {isLoading} >
                        Submit 
                    </Button> 
                    <Button onClick = {onBizModalClose} > Cancel </Button> 
                </ModalFooter> 
            </ModalContent> 
        </Modal> 
        {/* --- END: Join as Businessman Modal --- */} 
    </div>
  );
}